import { Page } from 'components/Page';
import { fetchPageDataOrNotFound } from 'lib/contentful';

export const Index = (props) => {
  return <Page {...props} />;
};

export const getServerSideProps = async (ctx) => {
  return fetchPageDataOrNotFound({ slug: 'home', ctx });
};

export default Index;
